export const shopFilters = [
  {
    label: "near.you",
    value: {
      near: "1",
    },
  },
  {
    label: "open.now",
    value: {
      open: "1",
    },
  },
  {
    label: "24/7",
    value: {
      work_24_7: "1",
    },
  },
  {
    label: "new",
    value: {
      column: "created_at",
      sort: "desc",
    },
  },
];
